var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "pause_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4a1 1 0 011-1h4a1 1 0 011 1v16a1 1 0 01-1 1H6a1 1 0 01-1-1V4zm2 1v14h2V5H7zM13 4a1 1 0 011-1h4a1 1 0 011 1v16a1 1 0 01-1 1h-4a1 1 0 01-1-1V4zm2 1v14h2V5h-2z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTUgNEM1IDMuNDQ3NzIgNS40NDc3MiAzIDYgM0gxMEMxMC41NTIzIDMgMTEgMy40NDc3MiAxMSA0VjIwQzExIDIwLjU1MjMgMTAuNTUyMyAyMSAxMCAyMUg2QzUuNDQ3NzIgMjEgNSAyMC41NTIzIDUgMjBWNFpNNyA1VjE5SDlWNUg3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMyA0QzEzIDMuNDQ3NzIgMTMuNDQ3NyAzIDE0IDNIMThDMTguNTUyMyAzIDE5IDMuNDQ3NzIgMTkgNFYyMEMxOSAyMC41NTIzIDE4LjU1MjMgMjEgMTggMjFIMTRDMTMuNDQ3NyAyMSAxMyAyMC41NTIzIDEzIDIwVjRaTTE1IDVWMTlIMTdWNUgxNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
export { SvgPause as ReactComponent };